<form *ngIf="!config.labelLeft" [formGroup]="group">
  <mat-slide-toggle
    [formControlName]="config.name"
    (click)="onClick.emit($event)"
    [disabled]="!!config.disabled"
    >{{ config.label }}</mat-slide-toggle
  >
</form>

<div *ngIf="config.labelLeft" fxFlex fxLayout="row" fxLayoutGap="8">
  <div fxFlex class="text-left">{{ config.label }}</div>
  <div fxFlex="initial">
    <form [formGroup]="group" fxLayout="row">
      <mat-slide-toggle
        [formControlName]="config.name"
        (click)="onClick.emit($event)"
        [disabled]="!!config.disabled"
      ></mat-slide-toggle>
    </form>
  </div>
</div>
